// extracted by mini-css-extract-plugin
export default {"heroBand":"MetalCloudPg_heroBand__rx971"};